import useSWR from "swr";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface PremiumIndexState {
  storeData: any;
  update: (symbol: string, data: any) => void;
}

const useChartPrice = create<PremiumIndexState>()(
  persist(
    (set) => ({
      storeData: {},
      update: (symbol, data) => {
        set((state) => {
          state.storeData[symbol] = data;
          return state;
        });
      },
    }),
    {
      name: "chart-index-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const useChartData = (symbol) => {
  const storeData = useChartPrice((state) => state.storeData);
  const update = useChartPrice((state) => state.update);

  const { mutate } = useSWR("@BINANCE/indexPriceKlines/" + symbol, async () => {
    const response = await fetch(
      `https://www.binance.com/fapi/v1/indexPriceKlines?pair=${symbol}&interval=12h?limit=50`
    );
    let data = await response.json();
    //[[1706788800000,"42085.16021277","43272.25382979","41946.31872340","43082.56090909","0",1706831999999,"0",43200,"0","0","0"]]
    //5번째값만
    data = data.map((d) => +d?.[4] || 0);

    //console.log(data);
    if (data) {
      update(symbol, data);
    }

    return data;
  });

  return {
    data: storeData[symbol] || [],
    mutate,
  };
};
